export default {
  offline: {
    show_booking: 'Voir la réservation',
    reminder: 'Rappel de vos données de réservation',
    your_message: 'Votre message',
    placeholder: 'Saisissez ici votre demande',
    dates: {
      title: 'Dates du séjour'
    },
    destination: {
      title: 'Destination'
    },
    favorite: {
      title: 'Lieu ou hôtel favoris'
    },
    research_priority: {
      title: 'Priorité de recherche',
      question: 'En cas de difficultés, priorité de recherche par',
      budget: 'budget',
      location: 'lieu'
    },
    contact_details: {
      title: 'Coordonnées voyageur(s)',
      question: 'Nombre de personnes prévues pour le voyage',
      traveller: {
        title: 'voyageur',
        look_for: 'rechercher un voyageur',
        drag_here: 'Glissez ici le voyageur',
        add_new: 'Ajouter un nouveau voyageur'
      }
    },
    requests: {
      title: 'Services souhaités de l\'hôtel',
      breakfast: 'Petit-déjeuner',
      catering: 'Restaurant',
      private_car_park: 'Parking privé',
      internet: 'Internet',
      disabled: 'Accès PMR'
    },
    rooms: {
      title: 'Nombre de chambres'
    },
    extra: {
      title: 'Commentaires'
    },
    refs: {
      title: 'Vos références de réservation'
    },
    confirm: {
      title: 'Demande envoyée',
      title_cancel: 'Demande annulée',
      phrase: 'Votre demande va être traitée par votre agent de réservation qui reviendra vers vous dans les plus brefs délais.',
      new_booking: 'Nouvelle réservation',
      booking_ref: 'Votre numéro de demande',
      validation: {
        title: 'Demande de Validation envoyée',
        phrase: 'Votre demande de réservation a été transmise à un manager de la société pour validation. Dès réponse traitée, vous recevrez une notification.'
      },
      default: {
        title: 'Demande envoyée',
        phrase: 'Votre demande va être traitée par votre agent de réservation qui reviendra vers vous dans les plus brefs délais.'
      }
    },
    draft: {
      title: 'Brouillon de votre réservation sauvegardé',
      phrase: 'Votre brouillon a été sauvegardé'
    },
    modify: {
      title: 'Modification de votre demande de réservation'
    },
    duplicate: {
      title: 'Duplication d\'une demande de réservation'
    },
    unlogged_error: '404 : page introuvable',
    bedType: {
      'adult-single': '2 lits jumeaux',
      'adult-double': '1 lit double'
    }
  }
}
